import { cn } from "@/lib/utils";
import { ArrowDown2 } from "iconsax-react";
import { ButtonHTMLAttributes, forwardRef } from "react";

type InputDropdownTriggerProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  label?: string;
};

const InputDropdownTrigger = forwardRef<
  HTMLButtonElement,
  InputDropdownTriggerProps
>(({ label, type = "button", className, ...props }, ref) => {
  return (
    <button
      ref={ref}
      type={type}
      className={cn(
        "relative inline-flex h-11 items-center rounded-xl border border-input bg-background py-2 pl-3 pr-10 text-base ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        !props.disabled && "hover:bg-secondary/60 focus-visible:outline-none",
        className,
      )}
      {...props}
    >
      {props.children ? props.children : label}
      <ArrowDown2 className="absolute right-3 top-0 h-full" size={20} />
    </button>
  );
});

InputDropdownTrigger.displayName = "InputDropdownTrigger";

export default InputDropdownTrigger;
